import * as Icons from "lucide-react";
import { Reveal, Chapter } from "../../lib/motion";
import { QUALITY } from "../../data";

export default function Quality() {
  return (
    <section data-testid="quality" className="py-24 md:py-32 bg-verra-base">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Chapter number="07" overline="Quality Assurance" title="Standards you can ship with confidence." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {QUALITY.map((q, i) => {
            const Icon = Icons[q.icon] || Icons.ShieldCheck;
            return (
              <Reveal key={q.title} delay={0.05 * i}>
                <div className="h-full rounded-2xl bg-white border border-verra-blue/10 p-7">
                  <div className="w-12 h-12 rounded-xl bg-verra-blue flex items-center justify-center mb-5">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="font-display text-xl text-verra-blue">{q.title}</h3>
                  <p className="text-sm text-verra-blue/60 mt-2 leading-relaxed">{q.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
